import { Typography, useMediaQuery } from '@mui/material';
import React from 'react';
import ansLogo from '../../../assets/images/ans-logo.png';
import TypographyAccessibility from '../../../components/Accessibility/TypographyAccessibility';
import { Carteirinha } from '../../../interfaces/entities/Carteirinha';
import { sxInfoBeneficiario, sxInfoBodyCartaoVerso, sxInfoBodyCartaoVersoBold, sxLabelInfoBeneficiario } from './sxProps';


export interface CardBackProps {
  getSelectBeneficiario: () => Carteirinha;
  showMoreInfo: boolean;
}


const CardBack: React.FC<CardBackProps> = ({ getSelectBeneficiario, showMoreInfo }) => {

  const isDesktop = useMediaQuery('(min-width: 1200px)');

  return (
    <div className='container-cartao-verso'>
      <div className='cartao-verso-body'>
        <div className='cartao-verso-info-prod'>
          <div>
            <Typography sx={sxInfoBodyCartaoVerso}><b>Área de Atuação do Produto: </b>Todos os clientes Unimed têm atendimento de urgência e emergência em todo território nacional nos prontos-socorros do Sistema Unimed.</Typography>
            <p />
            <Typography sx={sxInfoBodyCartaoVerso}>Cobertura completa e eletiva na área de atuação da Unimed Campinas: Artur Nogueira, Campinas, Cosmópolis, Holambra, Hortolândia, Indaiatuba, Jaguariúna, Monte Mor, Paulínia, Santo Antônio de Posse, Sumaré, Valinhos e Vinhedo.</Typography>
          </div>
          <div>
            {getSelectBeneficiario().carencias.map((carencia) =>
              <Typography key={carencia.descrGrupoCarencia} sx={sxInfoBodyCartaoVerso}>{carencia.descrGrupoCarencia}</Typography>
            )}
          </div>
          <div>
            <Typography sx={sxInfoBodyCartaoVersoBold}>{getSelectBeneficiario().codigoProduto}</Typography>
            <Typography sx={sxInfoBodyCartaoVerso}>Cod. Produto ANS</Typography>
          </div>
          <div>
            <Typography sx={sxInfoBodyCartaoVersoBold}>{getSelectBeneficiario().cns}</Typography>
            <Typography sx={sxInfoBodyCartaoVerso}>CNS</Typography>
          </div>
        </div>
        <div className='cartao-verso-info-unimed'>
          <div>
            <Typography className='cartao-verso-align-center' sx={sxInfoBodyCartaoVerso}>Eventuais alterações ocorridas na rede de prestadores poderão ser consultadas no www.unimedcampinas.com.br e no tel. 0800 013 66 88</Typography>
            <p />
            <Typography className='cartao-verso-align-center' sx={sxInfoBodyCartaoVerso}>Disque ANS: 0800 701 9656 www.ans.gov.br</Typography>
          </div>
          <div className='cartao-verso-sac-container'>
            <div>
              <Typography className='cartao-verso-align-center' sx={sxInfoBodyCartaoVerso}>SAC/Informações</Typography>
              <Typography sx={sxInfoBodyCartaoVersoBold}>0800 013 66 88</Typography>
              <div className='cartao-verso-container-ans-logo'>
                <img src={ansLogo} alt='Logo ANS' />
              </div>
            </div>
            <div>
              <Typography className='cartao-verso-align-center' sx={sxInfoBodyCartaoVerso}>Unimed Help 24h</Typography>
              <Typography sx={sxInfoBodyCartaoVersoBold}>0800 055 88 85</Typography>
            </div>
          </div>
        </div>
      </div>
      {isDesktop &&
        <>
          <div className='more-info-container'>
            {showMoreInfo &&
              <div style={{ height: '201px' }} />
            }
          </div>
          <div className='container-info-beneficiario'>
            <div >
              <TypographyAccessibility sx={sxLabelInfoBeneficiario}>Segmentação Assistencial do plano:</TypographyAccessibility>
              <TypographyAccessibility sx={sxInfoBeneficiario}>{getSelectBeneficiario().segmentacaoAssistencialPlano.toLowerCase()}</TypographyAccessibility>
            </div>
            <div className='info-beneficiario'>
              <TypographyAccessibility sx={sxLabelInfoBeneficiario}>Rede de Atendimento:</TypographyAccessibility>
              <TypographyAccessibility sx={sxInfoBeneficiario}>{getSelectBeneficiario().redeDeAtendimento.toLowerCase()}</TypographyAccessibility>
            </div>
            <div className='info-beneficiario'>
              <TypographyAccessibility sx={sxLabelInfoBeneficiario}>Atendimento:</TypographyAccessibility>
              <TypographyAccessibility sx={sxInfoBeneficiario}>{getSelectBeneficiario().atendimento.toLowerCase()}</TypographyAccessibility>
            </div>
            <div className='info-beneficiario'>
              <TypographyAccessibility sx={sxLabelInfoBeneficiario}>Cod. Produto ANS:</TypographyAccessibility>
              <TypographyAccessibility sx={sxInfoBeneficiario}>{getSelectBeneficiario().codigoProduto}</TypographyAccessibility>
            </div>
            <div className='info-beneficiario'>
              <TypographyAccessibility sx={sxLabelInfoBeneficiario}>CNS:</TypographyAccessibility>
              <TypographyAccessibility sx={sxInfoBeneficiario}>{getSelectBeneficiario().cns.toLowerCase()}</TypographyAccessibility>
            </div>
          </div>
        </>
      }
    </div >
  )
}

export default CardBack